// extracted by mini-css-extract-plugin
module.exports = {"OrdersFilters":"OrdersFilters_OrdersFilters__3eC9m","Input":"OrdersFilters_Input__1XutP","Search":"OrdersFilters_Search__1WKzN","Filter":"OrdersFilters_Filter__3-rQ5"};